<template>
    <b-tabs
     vertical
     nav-wrapper-class="nav-vertical"
    >
      <b-tab title-item-class="user-tab" active>
        <template #title>
          <feather-icon class="align-middle" icon="UserIcon" />
          <span class="align-middle pl-2 pr-3">Dane osobowe</span>
        </template>
        <vx-card>
         <user-data />
        </vx-card>
      </b-tab>
<!--      <b-tab title-item-class="user-tab" lazy>-->
<!--        <template #title>-->
<!--          <feather-icon class="align-middle" icon="LockIcon" />-->
<!--          <span class="align-middle pl-2 pr-3">Zmień hasło</span>-->
<!--        </template>-->
<!--        <vx-card>-->
<!--          <change-password />-->
<!--        </vx-card>-->
<!--      </b-tab>-->

    </b-tabs>
</template>

<script>
import UserData from './my-account/UserData'
import ChangePassword from './my-account/ChangePassword'

export default {
    name: 'MyAccount',
    components:{
        UserData,
        ChangePassword
    }
}
</script>
<style lang="scss">
.nav-tabs {
  border: none;
  .user-tab .nav-link{
    position: relative;
    background: none !important;
    border: none;
    &:not(.active) {
      color: $grey;
      &:after {
        content: '';
        width: 0;
        height: 100%;
        border: 1px solid $grey;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    &.active {
      color: $secondary;
      &:after {
        content: '';
        width: 0;
        height: 100%;
        border: 1px solid $secondary;
        position: absolute;
        box-shadow: 0px 0px 2px $secondary;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>
